(() => {
  if (customElements.get('whiff-note-controller')) return;
  class WhiffNoteController extends HTMLElement {}
  customElements.define('whiff-note-controller', WhiffNoteController);
  const hoverAvailable = matchMedia('(hover: hover) and (pointer: fine)');
  let active = null;
  function setup(library) {
    if (library.dataset.ready) return;
    library.dataset.ready = 'true';
    const section = library.closest('.shopify-section');
    if (!section) return;
    const entries = new Map();
    library.querySelectorAll('template[data-note-key]').forEach(item => {
      [item.dataset.noteKey, ...(item.dataset.noteAliases || '').split('|')].forEach(alias => {
        if (alias) entries.set(alias.trim().toLocaleLowerCase(), item);
      });
    });
    const cards = [];
    function enhance() {
      const list = section.querySelector('[data-whiff-scent][data-enhanced] .whiff-notes');
      if (!list) return false;
      list.querySelectorAll('dd').forEach(detail => {
        if (detail.querySelector('.whiff-note-trigger')) return;
        const parts = detail.textContent.split(/(,\s*|;\s*|\s+·\s+)/);
        const fragment = document.createDocumentFragment();
        parts.forEach(part => {
          const entry = entries.get(part.trim().toLocaleLowerCase());
          if (!entry) { fragment.append(document.createTextNode(part)); return; }
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'whiff-note-trigger'; button.textContent = part;
          button.setAttribute('aria-haspopup', 'dialog'); button.setAttribute('aria-expanded', 'false');
          const card = entry.content.firstElementChild.cloneNode(true);
          card.id = `whiff-note-${library.dataset.whiffNoteLibrary}-${cards.length}`;
          const title = card.querySelector('h2'); title.id = card.id + '-title';
          card.setAttribute('aria-labelledby', title.id);
          button.setAttribute('aria-controls', card.id);
          section.append(card); cards.push(card);
          let openTimer, closeTimer, pinned = false;
          const clearTimers = () => { clearTimeout(openTimer); clearTimeout(closeTimer); };
          function position() {
            const rect = button.getBoundingClientRect();
            const view = window.visualViewport;
            const vw = view?.width || innerWidth, vh = view?.height || innerHeight;
            const vx = view?.offsetLeft || 0, vy = view?.offsetTop || 0;
            const width = card.offsetWidth, height = card.offsetHeight;
            const left = Math.max(vx + 12, Math.min(rect.left + rect.width / 2 - width / 2, vx + vw - width - 12));
            let top = rect.top - height - 10;
            if (top < vy + 12) top = rect.bottom + 10;
            top = Math.max(vy + 12, Math.min(top, vy + vh - height - 12));
            card.style.left = left + 'px'; card.style.top = top + 'px';
          }
          function close(restore = false) {
            clearTimers(); pinned = false;
            if (card.matches(':popover-open')) card.hidePopover();
            button.setAttribute('aria-expanded', 'false');
            if (active?.card === card) active = null;
            if (restore) button.focus({preventScroll: true});
          }
          function open(pin = false) {
            clearTimers();
            if (active && active.card !== card) active.close();
            pinned = pinned || pin;
            if (!card.matches(':popover-open')) card.showPopover();
            button.setAttribute('aria-expanded', 'true');
            position(); active = {card, button, close, position};
          }
          function scheduleClose() {
            clearTimeout(openTimer);
            closeTimer = setTimeout(() => {
              if (!pinned && !card.matches(':hover') && !button.matches(':hover') && !card.contains(document.activeElement)) close();
            }, 180);
          }
          button.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse' && hoverAvailable.matches) { clearTimers(); openTimer = setTimeout(() => open(), 140); }
          });
          button.addEventListener('pointerleave', scheduleClose);
          button.addEventListener('click', () => {
            if (pinned && card.matches(':popover-open')) close();
            else open(true);
          });
          button.addEventListener('keydown', event => {
            if (event.key === 'ArrowDown') { event.preventDefault(); open(true); card.querySelector('button').focus(); }
          });
          card.addEventListener('pointerenter', clearTimers);
          card.addEventListener('pointerleave', scheduleClose);
          card.addEventListener('focusout', event => { if (!card.contains(event.relatedTarget) && event.relatedTarget !== button) close(); });
          button.addEventListener('blur', event => { if (!card.contains(event.relatedTarget)) close(); });
          card.querySelector('.whiff-note-close').addEventListener('click', () => close(true));
          card.addEventListener('toggle', () => {
            if (!card.matches(':popover-open')) { pinned = false; button.setAttribute('aria-expanded','false'); if (active?.card === card) active = null; }
          });
          fragment.append(button);
        });
        detail.replaceChildren(fragment);
      });
      return true;
    }
    if (!enhance()) {
      const observer = new MutationObserver(() => { if (enhance()) observer.disconnect(); });
      observer.observe(section, {childList: true, subtree: true});
      setTimeout(() => observer.disconnect(), 10000);
    }
  }
  const init = (scope = document) => scope.querySelectorAll('[data-whiff-note-library]').forEach(setup);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && active) { event.preventDefault(); active.close(true); }
  });
  window.addEventListener('resize', () => active?.position(), {passive: true});
  document.addEventListener('scroll', event => {
    if (active && !active.card.contains(event.target)) {
      const rect = active.button.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight) active.close();
      else active.position();
    }
  }, {capture: true, passive: true});
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => active?.close());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
